export const DEBOUNCE_DELAY = 500; // 500ms
export const DEFAULT_AVATAR =
  'https://i.pinimg.com/736x/9f/16/72/9f1672710cba6bcb0dfd93201c6d4c00.jpg';
export const DEFAULT_AVATAR_URL_API =
  'https://files.fullstack.edu.vn/f8-tiktok/';

export const STICKER_CATEGORIES = [
  {
    name: 'Smileys',
    stickers: [
      '😀',
      '😁',
      '😂',
      '🤣',
      '😃',
      '😄',
      '😅',
      '😆',
      '😉',
      '😊',
      '😋',
      '😎',
      '😍',
      '😘',
      '🥰',
      '😗',
      '😙',
      '😚',
      '🙂',
      '🤗',
      '🤩',
      '🤔',
      '🤨',
      '😐',
      '😑',
      '😶',
      '🙄',
      '😏',
      '😣',
      '😥',
      '😮',
      '🤐',
      '😯',
      '😪',
      '😫',
      '😴',
      '😌',
      '😛',
      '😜',
      '😝',
      '🤤',
      '😒',
      '😓',
      '😔',
      '😕',
      '🙃',
      '🫠',
      '🫥',
      '😷',
      '🤒',
      '🤕',
      '🤢',
      '🤮',
      '🤧',
      '🥵',
      '🥶',
      '🥴',
      '😵',
      '🤯',
      '🤠',
      '🥳',
      '😇',
      '🥹',
      '🫨',
      '🫤',
      '😬',
      '🫣',
      '🫡',
    ],
  },
  {
    name: 'Special',
    stickers: [
      '😈',
      '👿',
      '💀',
      '💩',
      '🤡',
      '👹',
      '👺',
      '👻',
      '👽',
      '👾',
      '🤖',
      '🎃',
      '🧙',
      '🧛',
      '🧟',
      '🧞',
      '🧜',
      '🧚',
      '🦸',
      '🦹',
      '🧝',
      '🧌',
      '🦷',
      '🦴',
      '🛸',
      '🪐',
      '🌈',
      '✨',
      '🔥',
      '⚡',
      '💥',
      '🌟',
      '💫',
      '🧿',
      '🎆',
      '🎇',
      '🪄',
      '🧨',
      '🎭',
      '🎪',
      '🎬',
      '🎮',
      '🕹️',
      '🧸',
      '🎁',
      '🎉',
      '🎊',
    ],
  },
  {
    name: 'Animals',
    stickers: [
      '🙈',
      '🙉',
      '🙊',
      '🐵',
      '🐒',
      '🦍',
      '🦧',
      '🐶',
      '🐕',
      '🦮',
      '🐩',
      '🐺',
      '🦊',
      '🦝',
      '🐱',
      '🐈',
      '🦁',
      '🐯',
      '🐅',
      '🐆',
      '🐴',
      '🐎',
      '🦓',
      '🦄',
      '🦌',
      '🐮',
      '🐂',
      '🐃',
      '🐄',
      '🐷',
      '🐖',
      '🐗',
      '🐏',
      '🐑',
      '🐐',
      '🐪',
      '🐫',
      '🦙',
      '🦒',
      '🐘',
      '🦣',
      '🦏',
      '🦛',
      '🐭',
      '🐁',
      '🐀',
      '🐹',
      '🐰',
      '🐇',
      '🐿️',
      '🦫',
      '🦔',
      '🦇',
      '🐻',
      '🐻‍❄️',
      '🐨',
      '🐼',
      '🦥',
      '🦦',
      '🦨',
      '🦘',
      '🦡',
      '🐾',
    ],
  },
  {
    name: 'Gestures',
    stickers: [
      '👍',
      '👎',
      '👌',
      '✌️',
      '🤞',
      '🤟',
      '🤘',
      '🤙',
      '🫶',
      '🫰',
      '👏',
      '🙌',
      '👐',
      '🤲',
      '🙏',
      '👊',
      '✊',
      '🤛',
      '🤜',
      '🤚',
      '🖐️',
      '✋',
      '🖖',
      '👋',
      '🤝',
      '✍️',
      '💅',
      '🦾',
      '🦿',
    ],
  },
  {
    name: 'Hearts',
    stickers: [
      '❤️',
      '🧡',
      '💛',
      '💚',
      '💙',
      '💜',
      '🖤',
      '🤍',
      '🤎',
      '💖',
      '💘',
      '💝',
      '💗',
      '💓',
      '💞',
      '💕',
      '💌',
      '💟',
      '❣️',
      '💔',
      '💤',
      '💢',
    ],
  },
];
